import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { AddDonation, getSingleDonation } from '../Common/apis';
import { toast } from 'react-toastify';
import Loader from '../Components/Loader/Loader';
import moment from 'moment';


function DonationDetail() {
    const { id } = useParams();
    const [value, setValue] = useState(16);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [donation, setDonation] = useState(null)
    const [loading, setLoading] = useState(false);


    const fetchDonation = async (id) => {
        setLoading(true);
        try {
            const response = await getSingleDonation(id);
            setDonation(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDonation(id);
    }, [id]);

    const handleChange = (e) => {
        setValue(e.target.value);
    };
    return (
        <>
            {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='pt-[50px] md:px-[110px] px-[20px]'>
                    <div className="grid md:grid-cols-2 grid-cols-1 md:pb-[100px] pb-[30px] md:gap-[62px] gap-[30px] justify-center">
                        <div className='max-w-[603px] w-full mx-auto'>
                            <img src={donation?.Image} className='w-[603px] rounded-[16px] h-[389px] object-cover' alt="" />
                            <div className='pt-[18px] flex flex-wrap gap-[18px]'>
                                {donation?.Images?.map((e, i) => {
                                    return (
                                        <div key={i}>
                                            <img
                                                src={e}
                                                alt={`gallery-${i}`}
                                                className='h-[101px] w-[137px] object-cover rounded-[10px]' />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className='max-w-[555px] w-full mx-auto'>
                            <h6 className="font-[700] font-manrope md:text-[40px] text-[24px] pb-[5px] text-[#333333]">{donation?.CampaignerName}</h6>
                            <div className="flex items-center pb-[36px] justify-between">
                                <p className="font-[400] text-[16px] font-manrope text-[#4D4D4D]">{moment(donation?.CampaignStartDate).format('MMM D, YYYY')}</p>
                                <button className='bg-[#FFEFE6] rounded-[16px] py-[6px] px-[16px] font-[600] font-manrope text-[11px] text-[#FF6000] text-center'>Donation</button>
                            </div>
                            <h6 className='font-[500] font-manrope text-[20px] text-[#666666]'><span className='font-[700] text-[#141414]'>0</span> from {donation?.TotalRequiredDonation}</h6>
                            <input
                                type="range"
                                id="range"
                                min="0"
                                max="100"
                                value={value}
                                onChange={handleChange}
                                className="w-full accent-[#FF6000]"
                            />
                            <div className="flex items-center justify-between pb-[33px]">
                                <h6 className="font-[400] font-manrope text-[16px] text-[#333333]"> 1,048 <span className='text-[#666666]'>Donators</span></h6>
                                <h6 className="font-[400] font-manrope text-[16px] text-[#333333]">22 <span className='text-[#666666]'> days left</span></h6>
                            </div>
                            <h6 className="font-[700] font-manrope text-[24px] pb-[14px] text-[#333333]">Campaigner</h6>
                            <div className='border border-[#DFE1E7] rounded-[12px] p-[12px] flex items-center gap-[8px] mb-[70px]'>
                                <div className='h-[52px] w-[52px] rounded-full bg-[#FFEFE6] flex justify-center items-center'>
                                    <h6 className="font-[600] font-manrope text-[20px] leading-[26px] text-[#FF6000] text-center">OF</h6>
                                </div>
                                <div>
                                    <h6 className="font-[700] font-manrope text-[17px] text-[#333333] flex items-center gap-[4px]">Orphan Foundation <img src="/assets/nav/verify.svg" alt="" /></h6>
                                    <p className="pt-[5px] font-manrope font-[400] text-[13px] text-[#4D4D4D] ">Verified Account from May 01 2023</p>
                                </div>
                            </div>
                            <button onClick={() => setIsModalOpen(true)} className='d-btn w-full text-center'>DONATE NOW</button>
                        </div>
                    </div>
                    <div>
                        <h6 className="font-[700] lg:text-[50px] text-[30px] font-manrope text-[#333333] pb-[16px]">Campaign story</h6>
                        <p className="font-[400] font-manrope text-[16px] leading-[34px] text-[#000000] pb-[16px]">Empower the Future: Scholarship Donations for Orphanages
                            <br /><br />
                            Join us in making a lasting impact on young lives by contributing to our Scholarship Donation Program for orphanages. Your generous donation will provide deserving children with access to quality education, opening doors to endless possibilities and a brighter future. Together, we can empower these young minds to achieve their dreams and transform their lives. Every contribution counts. Be the change-maker today and help shape a better tomorrow for these children.</p>
                        <button className='font-[700] font-manrope text-[13px] text-[#FF6000] pb-[50px]'>Read more</button>
                    </div>
                    <div className="flex flex-col gap-[5px]">
                        <div className='flex justify-between items-center'>
                            <div className="flex gap-[8px] items-center">
                                <h6 className="font-[600] font-manrope text-[24px] text-[#666666]">Donators</h6>
                                <button className='bg-[#FFEFE6] font-[500] font-manrope text-[16px] text-[#FF6000] py-[4px] px-[12px] rounded-full'>1.048</button>
                            </div>
                            <button>
                                <img src="/assets/nav/chevron-right.svg" alt="" />
                            </button>
                        </div>
                        <div className="flex flex-col gap-[8px] md:pb-[54px] pb-[30px]">
                            <div className='bg-[#F6F8FA] flex justify-between items-center rounded-[12px] p-[12px]'>
                                <div className="flex items-center gap-[12px]">
                                    <img src="/assets/nav/img1.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] font-manrope text-[16px] text-[#36394A] pb-[2px]">Anonymous</h6>
                                        <p className="font-[500] font-manrope text-[13px] text-[#4D4D4D]">Donate $20</p>
                                    </div>
                                </div>
                                <p className="font-[400] font-manrope text-[11px] text-[#666D80]">1 minute ago</p>
                            </div>
                            <div className='bg-[#F6F8FA] flex justify-between items-center rounded-[12px] p-[12px]'>
                                <div className="flex items-center gap-[12px]">
                                    <img src="/assets/nav/img1.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] font-manrope text-[16px] text-[#36394A] pb-[2px]">Anonymous</h6>
                                        <p className="font-[500] font-manrope text-[13px] text-[#4D4D4D]">Donate $20</p>
                                    </div>
                                </div>
                                <p className="font-[400] font-manrope text-[11px] text-[#666D80]">1 minute ago</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[5px]">
                        <div className='flex justify-between items-center'>
                            <div className="flex gap-[8px] items-center">
                                <h6 className="font-[600] font-manrope text-[24px] text-[#666666]">Wishes</h6>
                                <button className='bg-[#FFEFE6] font-[500] font-manrope text-[16px] text-[#FF6000] py-[4px] px-[12px] rounded-full'>234</button>
                            </div>
                            <button>
                                <img src="/assets/nav/chevron-right.svg" alt="" />
                            </button>
                        </div>
                        <div className="flex flex-col gap-[8px] md:pb-[170px] pb-[70px]">
                            <div className='bg-[#F6F8FA] rounded-[12px] px-[12px] py-[8px] flex flex-col gap-[12px]'>
                                <div className="flex items-center gap-[12px]">
                                    <img src="/assets/nav/img1.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] font-manrope text-[16px] text-[#36394A] pb-[2px]">Anonymous</h6>
                                        <p className="font-[400] font-manrope text-[11px] text-[#666D80]">10 minute ago</p>
                                    </div>
                                </div>
                                <p className="font-[400] font-manrope text-[11px] text-[#333333]">With this scholarship, we believe in your abilities and dreams. May you find the strength and determination to achieve everything you set your heart on.</p>
                                <p className="font-[400] font-manrope text-[11px] text-[#666666]"><span className='font-[700] text-[#333333]'>15 people</span> loved this wishes</p>
                                <div className="w-full h-[1px] bg-[#DFE1E7]"></div>
                                <div className="grid grid-cols-2">
                                    <div className='flex justify-start items-center gap-[4px]'>
                                        <img src="/assets/nav/heart.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[11px] text-[#666666]">Love</p>
                                    </div>
                                    <div className='flex justify-center items-center gap-[4px]'>
                                        <img src="/assets/nav/share-square.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[11px] text-[#666666]">Share</p>
                                    </div>
                                </div>
                            </div>
                            <div className='bg-[#F6F8FA] rounded-[12px] px-[12px] py-[8px] flex flex-col gap-[12px]'>
                                <div className="flex items-center gap-[12px]">
                                    <img src="/assets/nav/img1.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] font-manrope text-[16px] text-[#36394A] pb-[2px]">Anonymous</h6>
                                        <p className="font-[400] font-manrope text-[11px] text-[#666D80]">10 minute ago</p>
                                    </div>
                                </div>
                                <p className="font-[400] font-manrope text-[11px] text-[#333333]">With this scholarship, we believe in your abilities and dreams. May you find the strength and determination to achieve everything you set your heart on.</p>
                                <p className="font-[400] font-manrope text-[11px] text-[#666666]"><span className='font-[700] text-[#333333]'>15 people</span> loved this wishes</p>
                                <div className="w-full h-[1px] bg-[#DFE1E7]"></div>
                                <div className="grid grid-cols-2">
                                    <div className='flex justify-start items-center gap-[4px]'>
                                        <img src="/assets/nav/heart.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[11px] text-[#666666]">Love</p>
                                    </div>
                                    <div className='flex justify-center items-center gap-[4px]'>
                                        <img src="/assets/nav/share-square.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[11px] text-[#666666]">Share</p>
                                    </div>
                                </div>
                            </div>
                            <div className='bg-[#F6F8FA] rounded-[12px] px-[12px] py-[8px] flex flex-col gap-[12px]'>
                                <div className="flex items-center gap-[12px]">
                                    <img src="/assets/nav/img1.png" alt="" />
                                    <div>
                                        <h6 className="font-[700] font-manrope text-[16px] text-[#36394A] pb-[2px]">Anonymous</h6>
                                        <p className="font-[400] font-manrope text-[11px] text-[#666D80]">10 minute ago</p>
                                    </div>
                                </div>
                                <p className="font-[400] font-manrope text-[11px] text-[#333333]">With this scholarship, we believe in your abilities and dreams. May you find the strength and determination to achieve everything you set your heart on.</p>
                                <p className="font-[400] font-manrope text-[11px] text-[#666666]"><span className='font-[700] text-[#333333]'>15 people</span> loved this wishes</p>
                                <div className="w-full h-[1px] bg-[#DFE1E7]"></div>
                                <div className="grid grid-cols-2">
                                    <div className='flex justify-start items-center gap-[4px]'>
                                        <img src="/assets/nav/heart.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[11px] text-[#666666]">Love</p>
                                    </div>
                                    <div className='flex justify-center items-center gap-[4px]'>
                                        <img src="/assets/nav/share-square.svg" alt="" />
                                        <p className="font-[400] font-manrope text-[11px] text-[#666666]">Share</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} id={id} onClose={() => setIsModalOpen(false)} />
        </>
    )
}

export default DonationDetail


function Modal({ isOpen, onClose, id }) {
    const [dropdown, setDropdown] = useState(true);
    const [amount, setAmount] = useState(""); // Step 1: Amount state

    const nominalOptions = ["100", "300", "500", "1000"];
    const navigate = useNavigate();

    const handleDonate = async () => {
        if (!amount || parseInt(amount) < 100) {
            toast.info("Minimum donation is Rs.50");
            return;
        }

        const raw = JSON.stringify({
            Campaign: id,
            DonationType: "Money",
            Amount: amount

        });


        try {
            const result = AddDonation(raw);
            toast.success(result.message);
            navigate("/donation");
        } catch (error) {
            toast.error(error.message);
        }
    };


    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[150] flex items-center justify-center bg-black bg-opacity-50"
            onClick={onClose}
        >
            <div
                className="max-w-[583px] w-full mx-auto rounded-[30px] bg-[#FFFFFF] p-[30px]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between pb-[18px] items-center">
                    <h6 className="font-[700] text-[24px] font-manrope text-[#2B2B2B]">Add your donation</h6>
                    <button onClick={onClose}>
                        <img src="/assets/nav/close.svg" alt="" />
                    </button>
                </div>
                <div className='flex flex-col gap-[8px] pt-[8px]'>
                    <div className='flex justify-between items-center' onClick={() => setDropdown(!dropdown)}>
                        <h6 className="font-[600] text-[16px] font-manrope text-[#2B2B2B]">Choose your nominal</h6>
                        <button>
                            <img className={`${dropdown ? "rotate-[270deg]" : "rotate-[90deg]"} transition-all duration-300`} src="/assets/nav/chevron-right.svg" alt="" />
                        </button>
                    </div>
                    {dropdown &&
                        nominalOptions.map((val, idx) => (
                            <div
                                key={idx}
                                className={`border border-[#DFE1E7] bg-[#FFFFFF] rounded-[16px] py-[8px] px-[12px] flex items-center justify-between cursor-pointer ${amount === val ? "border-[#F1592A]" : ""}`}
                                onClick={() => setAmount(val)}
                            >
                                <div className='flex items-center gap-[8px]'>
                                    <img src="/assets/nav/wallet.svg" alt="" />
                                    <p className="font-[600] font-manrope text-[16px] text-[#2B2B2B]">IDR{parseInt(val).toLocaleString()}</p>
                                </div>
                                {amount === val && <img src="/assets/nav/check.svg" alt="selected" />}
                            </div>
                        ))
                    }
                </div>
                <div className="pt-[16px]">
                    <h6 className="pb-[10px] text-[#666666] font-inter font-[600] text-[16px] leading-[24px]">Other nominal</h6>
                    <div className='bg-[#F6F8FA] border border-[#DFE1E7] rounded-[16px] p-[12px] items-center grid grid-cols-2 gap-[12px]'>
                        <select name="" id="" className='border-none bg-transparent font-[700] font-manrope text-[16px] text-[#333333] focus:outline-none py-[7px] px-[4px]'>
                            <option value="">IDR</option>
                        </select>
                        <p className="text-right font-[700] text-[16px] text-[#333333] pr-[4px]">{amount}</p>
                    </div>
                    <p className="pt-[10px] pb-[54px] font-[400] font-manrope text-[14px] text-[#666666]">The minimum donation is IDR15.000</p>
                    <button onClick={handleDonate} className='d-btn w-full text-center'>PAYMENT NOW</button>
                </div>
            </div>
        </div>
    );
}
